import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { alertActions } from '../../_actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import ModalForm from './modal'
import { Button } from 'react-bootstrap'
import DeleteForm from './deleteform.component'
import { useTranslation } from "react-i18next"

function DeleteButton(props) {

	const [show, setShow] = useState(false)
    const {t} = useTranslation('common')
    const dispatch = useDispatch()

    function handleConfirm () {
        setShow(false)
        props.confirmClick(props.data)
    }

    const onClick = () => {
        dispatch(alertActions.clear());
        setShow(true)
    }

    return (
        <>
	        <Button
	            onClick={onClick}
	            title={t("crudtable.delete.button")}
	            size="sm"
	            color="info"
	            variant="outline-danger">
	            <FontAwesomeIcon icon={faTrash}/>
	        </Button>
	        <ModalForm
	            data={props.data}
	            show={show}
	            handleConfirm={handleConfirm}
	            handleClose={() => setShow(false)}
	            modalHeader={t("crudtable.delete.header")}
	            modalBody={<DeleteForm />}
	        />
        </>
    )

}

export default DeleteButton